interface DurationInputProps {
  value: number | undefined;
  onChange: (value: number | undefined) => void;
  type: 'timeout' | 'ban';
}

const DURATION_PRESETS = {
  timeout: [
    { label: '1분', value: 60 },
    { label: '5분', value: 300 },
    { label: '10분', value: 600 },
    { label: '30분', value: 1800 },
    { label: '1시간', value: 3600 },
    { label: '6시간', value: 21600 },
    { label: '12시간', value: 43200 },
    { label: '1일', value: 86400 },
  ],
  ban: [
    { label: '1일', value: 86400 },
    { label: '3일', value: 259200 },
    { label: '7일', value: 604800 },
    { label: '14일', value: 1209600 },
    { label: '30일', value: 2592000 },
  ],
};

export default function DurationInput({ value, onChange, type }: DurationInputProps) {
  const presets = DURATION_PRESETS[type];

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-4 gap-2">
        {presets.map((preset) => (
          <button
            key={preset.value}
            type="button"
            onClick={() => onChange(preset.value)}
            className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
              value === preset.value
                ? 'bg-gradient-to-r from-[#FF7A7A] to-[#DD8DFF] text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            {preset.label}
          </button>
        ))}
      </div>

      <div>
        <label className="block text-xs text-gray-600 mb-1">
          또는 직접 입력 (초)
        </label>
        <input
          type="number"
          value={value || ''}
          onChange={(e) => onChange(parseInt(e.target.value) || undefined)}
          placeholder="예: 3600"
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
    </div>
  );
}
